// extracted by mini-css-extract-plugin
export default {"container":"LPEmx","containerBorder":"TTNKc","header":"xB9jx","content":"d4cVH","controls":"k+y89"};